<div class="confirm-dialog">
  <awc-button
    text="Cancel"
    [type]="alttype"
    [size]="size"
    (buttonClicked)="cancel()"></awc-button>
  <awc-button
    text="Confirm"
    [type]="type"
    [size]="size"
    (buttonClicked)="confirm()"></awc-button>
</div>
